import React from 'react'
import { TextField, RaisedButton } from 'material-ui'
import { cyan900 } from 'material-ui/styles/colors';
import Checkbox from 'material-ui/Checkbox'
import Snackbar from 'material-ui/Snackbar'

const styles = {
  floatingLabelStyle: {
    color: cyan900,
  },
  inline: {
    display: 'flex',
    width: '70%',
  },
  inputStyle: {
    marginRight: '2%',
    width: '300px',
  },
  radioButton: {
    marginBottom: 16,
    float: 'left',
    display: 'inline-block',
    width: '190px',
  },
}

class ShippingOptions extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  render() {
    const { shipping, handleChange, index, saveShippingOptions, openShipping } = this.props
    const { description, name, price, free_cutoff, disabled, id } = shipping
    const priceLabel = shipping.label == 'FREE SHIPPING' ? 'price must be UNDER $9,00' : 'price must be OVER $9,00'
    return (
      <div>
        <hr></hr> 
        {shipping.label}
        <div className="row">
          <div className="col-md-6 col-lg-4">
            <TextField
              floatingLabelStyle={styles.floatingLabelStyle}
              name={`shippingOptions[${index}].name`}
              style={styles.inputStyle}
              floatingLabelText='Name'
              floatingLabelFixed={true}
              value={name}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6 col-lg-4">
            <TextField
              floatingLabelStyle={styles.floatingLabelStyle}
              name={`shippingOptions[${index}].description`}
              style={styles.inputStyle}
              floatingLabelText='Description'
              floatingLabelFixed={true}
              value={description}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6 col-lg-4">
            <TextField
              floatingLabelStyle={styles.floatingLabelStyle}
              name={`shippingOptions[${index}].price`}
              style={styles.inputStyle}
              floatingLabelText={priceLabel}
              floatingLabelFixed={true}
              value={price}
              onChange={handleChange}
              type='number'
            />
          </div>
          <div className="col-md-6 col-lg-4">
            <TextField
              floatingLabelStyle={styles.floatingLabelStyle}
              name={`shippingOptions[${index}].free_cutoff`}
              style={styles.inputStyle}
              floatingLabelText='Free Cutoff'
              floatingLabelFixed={true}
              value={free_cutoff}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6 col-lg-4">
            <Checkbox
              label="Disabled"
              name={`shippingOptions[${index}].disabled`}
              defaultChecked={disabled}
              onCheck={handleChange}
            />
          </div>
        </div>
        <br /><br />
          <RaisedButton
            label="Save Shipping Option"
            primary
            onClick={(e) => { e.preventDefault(); saveShippingOptions(index)}}
          ></RaisedButton>
          <Snackbar
            open={openShipping}
            message={`Saving Shipping Option`}
            autoHideDuration={5000}
          />
      </div>
    )
  }
}

export default ShippingOptions


// WEBPACK FOOTER //
// ./src/components/settings/ShippingOptions.js